import { ChangeEvent, FC } from 'react';
import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';
import { ErrorMessage, Field, FieldArray } from 'formik';
import clsx from 'clsx';
import { useStyles } from '../../styles';
import { Coin } from '../../../../../../models/Coin';

interface Props {
    value: Coin[];
    setFieldValue: (fieldName: string, value: string) => void;
}

const CoinsField: FC<Props> = ({ value, setFieldValue }) => {
    const classes = useStyles();

    const renderCoinFields = () => (
        <FieldArray
            name="coins"
            render={arrayHelpers => (
                <div>
                    {value?.map((coin: Coin, index: number) => (
                        <Grid container key={index} className={clsx(classes.formGridRow, classes.coinsRow)}>
                            <Grid item>
                                <Field
                                    component={TextField}
                                    name={`coins.${index}.coinName`}
                                    placeholder="Coin Name"
                                    variant="outlined"
                                    InputProps={{ className: classes.field }}
                                    fullWidth
                                    onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                        setFieldValue(`coins.${index}.coinName`, event.target.value)
                                    }
                                />
                                <p className={classes.errorText}>
                                    <ErrorMessage name={`coins.${index}.coinName`} />
                                </p>
                            </Grid>

                            <Grid item>
                                <Field
                                    component={TextField}
                                    name={`coins.${index}.coinId`}
                                    placeholder="Coin Symbol"
                                    variant="outlined"
                                    InputProps={{ className: classes.field }}
                                    fullWidth
                                    onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                        setFieldValue(`coins.${index}.coinId`, event.target.value)
                                    }
                                />
                                <p className={classes.errorText}>
                                    <ErrorMessage name={`coins.${index}.coinId`} />
                                </p>
                            </Grid>

                            <Grid item>
                                <Field
                                    component={TextField}
                                    name={`coins.${index}.minCoinBalance`}
                                    placeholder="Minimum balance"
                                    variant="outlined"
                                    InputProps={{ className: classes.field }}
                                    fullWidth
                                    onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                        setFieldValue(`coins.${index}.minCoinBalance`, event.target.value)
                                    }
                                />
                                <p className={classes.errorText}>
                                    <ErrorMessage name={`coins.${index}.minCoinBalance`} />
                                </p>
                            </Grid>
                            <Grid item className={classes.removeButtonGridItem}>
                                <Button type="button" onClick={() => arrayHelpers.remove(index)}>
                                    Remove coin
                                </Button>
                            </Grid>
                        </Grid>
                    ))}

                    <Button
                        type="button"
                        onClick={() => arrayHelpers.push({ coinName: '', coinId: '', minCoinBalance: '' })}
                    >
                        Add a coin
                    </Button>

                    {value.length === 0 && (
                        <p className={classes.errorText}>
                            <ErrorMessage name="coins" />
                        </p>
                    )}
                </div>
            )}
        />
    );

    return (
        <Box className={classes.row}>
            <Typography className={classes.label}>Coins</Typography>
            {renderCoinFields()}
        </Box>
    );
};

export default CoinsField;
